export enum PaymentInput {
    CardNumber = 'cardNumber',
    CardExpiry = 'cardExpiry',
    CardCvv = 'cardCvc',
}
